const cancelLabel = { // 0
    background: '#FF0000',
    color: 'white'
}
const initialLabel = { // Burası da state boş olan
    background: '#D3D3D3',
    color: 'white'
}
const finalLabel = { // 3
    background: '#50C878',
    color: 'white'
}
const progressLabel = { // 1-2
    background: '#FFBF00',
    color: 'white'
}

const currentLabel = { 
    borderColor : 'red',
    borderWidth : '4px'
}


export {
  cancelLabel,
  initialLabel,
  finalLabel,
  progressLabel,
  currentLabel,
};
